const SUBSCRIBED_STATUSES = ["active", "cancelled"];

function readBlclientData() {
  if (typeof window === "undefined" || !window.blclient || !window.blclient.data) {
    return {};
  }
  return window.blclient.data;
}

// The one "is this a paying subscriber" rule: a current (active or cancelled-but-running) paid plan.
function isPaidSubscription(subscriberData, subscriptionPlanData) {
  const status = subscriberData && subscriberData.status ? String(subscriberData.status).toLowerCase() : "";
  if (!SUBSCRIBED_STATUSES.includes(status)) {
    return false;
  }
  const price = Number(subscriptionPlanData && subscriptionPlanData.price);
  return Number.isFinite(price) && price > 0;
}

function isViewerSubscribed() {
  const data = readBlclientData();
  return isPaidSubscription(data.subscriberData || null, data.subscriptionPlanData || null);
}

module.exports = { isPaidSubscription, isViewerSubscribed };
